<template>
  <div>
    <el-cascader ref="CityCascader" :options="options" v-model="cityData" @change="handleChange" size="small" style="width: 100%;"></el-cascader>
  </div>
</template>

<script>
let id = 0;
import cityJson from './assets/cityData';
export default {
  name: 'CityCascader',
  props: {
    value: null
  },
  data() {
    return {
      cityData: this.value,
      options: []
    };
  },
  computed: {
    newCityData() {
      return JSON.parse(JSON.stringify(cityJson));
    }
  },
  created() {
    var that = this;
    this.options = this.newCityData
      .filter(item => {
        return item.parentId === '100000';
      })
      .map(item => {
        let children = that.getData(item.id);

        let newchildren = children.map(citem => ({
          value: citem.value,
          label: citem.label,
          children: that.getData(citem.value)
        }));

        return {
          value: item.id,
          label: item.name,
          children: newchildren
        };
      });

    console.log(that.options);
  },
  methods: {
    // setCascaderValue() {
    //   this.cityData = this.value;
    //    this.$emit('input', this.value)
    // },
    getData(id) {
      return this.newCityData
        .filter(item => {
          return item.parentId === id;
        })
        .map(item => ({
          value: item.id,
          label: item.name
        }));
    },
    handleChange(value) {
      console.log('handleChange:', value);
    }
  },
  watch: {
    cityData(newVal) {
      this.$emit('input', newVal)
    }
  }
};
</script>

<style></style>
